export default __webpack_public_path__ + "static/media/tool-field-indoor-half.d74b9849.svg";